import React, { cloneElement } from 'react';

import s from './PowerStationStatsItem.module.scss';

type Props = {
  title?: string;
  info?: number | string;
  image?: React.ReactElement;
};

export const PowerStationStatsItem = ({ image, title, info }: Props) => {
  return (
    <div className={s.powerStationStatsItem}>
      {image &&
        cloneElement(image, {
          className: s.powerStationStatsItem__image,
        })}
      {title && info && (
        <div className={s.powerStationStatsItem__wrap}>
          <div className={s.powerStationStatsItem__title}>{title}</div>
          <div className={s.powerStationStatsItem__info}>{info}</div>
        </div>
      )}
    </div>
  );
};
